import * as React from 'react';

import { Props } from './types';
import { arePropsEqual } from './utils';

const NavigationBack = React.memo(
  ({ className }: Props) => (
    <svg
      data-testid="navigation-back-icon"
      className={className}
      viewBox="0 0 16 14"
      height="14"
      width="16"
    >
      <path d="M16 6.444H3.378l3.2-3.2L5.333 2 0 7.333l5.333 5.334 1.245-1.245-3.2-3.2H16z" />
    </svg>
  ),
  arePropsEqual
);

export default NavigationBack;
